<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('profilestrategy_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-strategy</v-icon>{{ item['uuid'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-profilestrategy-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.strategy.uuid') }}</strong></td>
              <td>
                                    {{ item['uuid'] }}
              </td>

              <td><strong>{{ $t('profile.strategy.software') }}</strong></td>
              <td>
                                    {{ item['software'].name }}
              </td>
            </tr>


          </tbody>
        </template>
      </v-simple-table>
      <template>
        <div class="profilestrategyquality-list">
          <Toolbar />

          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12>
                <h1>{{$t('profile.strategy.qualities')}}</h1>
              </v-flex>
              <v-flex lg12>
                <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                  <ProfileStrategyQualityFilterForm
                    ref="filterForm"
                    :values="filters"
                    slot="filter"
                  />
                </DataFilter>

                <br />

                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
        :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
@click:row="showHandlerSubEvent"
                >

                  <ActionCell
                    slot="item.action"
                    slot-scope="props"
                    :handle-show="() => showHandlerSub(item,'ProfileStrategyQuality',props.item)"
                  ></ActionCell>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProfileStrategyQualityFilterForm from '../../components/profilestrategyquality/Filter';
import DataFilter from '../../components/DataFilter';

const servicePrefix = 'ProfileStrategy';

export default {
  name: 'ProfileStrategyShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ActionCell,
      ProfileStrategyQualityFilterForm,
      DataFilter
  },
  mixins: [ListMixin,ShowMixin,AccessMixin],
  data() {
    return {
      headers: [
        { text: this.$t('profile.strategy.quality'), value: 'quality.name' },
        { text: this.$t('profile.strategy.part'), value: 'part' },
        { text: this.$t('profile.strategy.infill'), value: 'infill' },
        { text: this.$t('profile.strategy.support'), value: 'support' },
        { text: this.$t('profile.strategy.densesupport'), value: 'denseSupport' },
        { text: this.$t('profile.strategy.skirt'), value: 'skirt' },
        { text: this.$t('profile.strategy.raft'), value: 'raft' },
        { text: this.$t('profile.strategy.primepillar'), value: 'primePillar' },
        { text: this.$t('profile.strategy.oozeshield'), value: 'oozeShield' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'profileStrategy' : this.$route.params.id,
      },
      selected: []
    };
  },
  computed: {
    ...mapFields('profilestrategy', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('profilestrategy', ['find']),
    ...mapGetters('profilestrategyquality', {
      items: 'list'
    }),
    ...mapFields('profilestrategyquality', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('profilestrategy', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('profilestrategyquality', {
      getPage: 'fetchAll',
    }),
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'ProfileStrategyQuality',value);
    }
  }
};
</script>
